import React from 'react';
import PropTypes from 'prop-types';
import { Popover as MUIPopover } from '@material-ui/core';

import { IPopoverProps } from '../../constants/commonTypes';


const Popover = (props: IPopoverProps) => {
  const {
    id,
    open,
    anchorEl,
    onClose,
    anchorVerticalPos,
    anchorHorizontalPos,
    transformHorizontalPos,
    transformVerticalPos,
    children,
  } = props;
  return (
    <MUIPopover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: anchorVerticalPos,
        horizontal: anchorHorizontalPos,
      }}
      transformOrigin={{
        vertical: transformVerticalPos,
        horizontal: transformHorizontalPos,
      }}
    >
      {children}
    </MUIPopover>
  )
}

Popover.defaultProps = {
  id: "",
  open: false,
  anchorEl: null,
  onClose: () => { },
  anchorVerticalPos: "",
  anchorHorizontalPos: "",
  transformHorizontalPos: "",
  transformVerticalPos: "",
  children: null,
}

Popover.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool,
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  anchorVerticalPos: PropTypes.string,
  anchorHorizontalPos: PropTypes.string,
  transformHorizontalPos: PropTypes.string,
  transformVerticalPos: PropTypes.string,
  children: PropTypes.node,
}

export default Popover;